<script>
    import {guid} from "../../Util/guid";

    export default {
        created(){
            //Prevent an empty prefix; an id is not allowed to start with a number
            this.id = this.generateId();
        },
        render(createElement, context) {
            const vm = this;

            const slotProps = {
                id: vm.id
            };
            
            if(this.elements){
                slotProps.idsPerElement = this.idsPerElement;
            }
            
            //ScopedSlots allow passing in props
            return createElement('fragment', [vm.$scopedSlots.default(slotProps)]);
        },
        methods: {
            generateId(){
                return `${this.prefix || '_'}${guid()}`; 
            },
            generateIdsForElements(){
                const vm = this;
                
                if(!vm.elements){
                    return;
                }

                //Weakmap entries are automagically removed when no references to it exist anymore
                //thus we can simply limit ourselves to just adding
                vm.elements
                    .filter(e => !vm.idsPerElement.has(e))
                    .forEach(e => vm.idsPerElement.set(e, vm.generateId()));
            }
        },
        watch: {
            elements(){
                this.generateIdsForElements();
            }
        },
        data: () => ({
            id: null,
            idsPerElement: new WeakMap()
        }),
        props: {
            prefix: {
                type: String,
                default: '_'
            },
            elements: {
                type: Array,
                required: false,
                default: () => undefined
            }
        }
    }
</script>